import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
  limit as fbLimit,
  doc,
  updateDoc,
  deleteDoc,
} from 'firebase/firestore'
import { db } from '@/config/firebase'
import type { SalesNote } from '@/lib/types'

const COLLECTION = 'sales_notes'

/**
 * Servicio de notas de venta (Ayudaventas).
 * Los vendedores dejan aquí lo que un cliente busca y no hay en tienda,
 * tallas faltantes, pedidos especiales, etc. Escritura/lectura directa
 * vía Firestore (protegido por reglas: requiere usuario autenticado).
 */
export class NotesService {
  static async addNote(
    note: Omit<SalesNote, 'id' | 'createdAt' | 'status'> & { status?: SalesNote['status'] }
  ): Promise<string> {
    const payload: Omit<SalesNote, 'id'> = {
      requestedItem: note.requestedItem?.trim() || '',
      note: note.note?.trim() || '',
      productId: note.productId ?? null,
      productName: note.productName ?? null,
      variant: note.variant ?? null,
      sellerEmail: note.sellerEmail ?? null,
      sellerName: note.sellerName ?? null,
      status: note.status ?? 'abierto',
      createdAt: Date.now(),
    }
    const ref = await addDoc(collection(db, COLLECTION), payload)
    return ref.id
  }

  static async getNotes(max = 100): Promise<SalesNote[]> {
    const q = query(collection(db, COLLECTION), orderBy('createdAt', 'desc'), fbLimit(max))
    const snap = await getDocs(q)
    return snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<SalesNote, 'id'>) }))
  }

  static async setStatus(id: string, status: SalesNote['status']): Promise<void> {
    await updateDoc(doc(db, COLLECTION, id), { status })
  }

  static async deleteNote(id: string): Promise<void> {
    await deleteDoc(doc(db, COLLECTION, id))
  }
}
